import { ICache } from "../interface/util";

interface ICachePrv extends ICache {
    store: {};
}

function Cache(): ICache {
    const val: ICachePrv = {
        store: {},
        add: function(this: ICachePrv, key: string|symbol, value: any): void {
            (this.store as any)[key] = value
        },
        get: function(this: ICachePrv, key: string|symbol): any {
            return (this.store as any)[key];
        },
    };

    return val as ICache;
}

export default Cache
